import { render, staticRenderFns } from "./OrganizationTypeSelect.vue?vue&type=template&id=5af8c06e&lang=pug&"
import script from "./OrganizationTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
